import React from "react";
import { FlipWords } from "../aceternity/ui/flip-words";
import { FocusCards } from "../aceternity/ui/focus-card";
import { Timeline } from "../aceternity/ui/timeline";
import temp1 from "../temp_assets/i1.jpg";
import temp2 from "../temp_assets/i2.jpg";
import temp3 from "../temp_assets/i3.jpg";
import temp4 from "../temp_assets/i5.jpg";
import temp5 from "../temp_assets/i6.jpg";
import temp6 from "../temp_assets/i7.jpg";
import temp7 from "../temp_assets/i8.jpg";
import temp8 from "../temp_assets/i10.png";
import temp9 from "../temp_assets/i11.png";
import temp10 from "../temp_assets/i12.png";
import temp11 from "../temp_assets/i13.png";
import temp12 from "../temp_assets/i1.jpg";
import model1 from "../temp_assets/i4.jpg"
import model2 from "../temp_assets/i9.png"
import "../styles/Hero.css";
const words = [" Indian Wear", " Men's Wear", " Women's Wear", " Kids' Wear"];
const cards = [
  {
    title: "Men's Wear",
    src: "./assets/hero2.jpeg",
  },
  {
    title: "Women's Wear",
    src: model1
  },
  {
    title: "Kids' Wear",
    src: model2
  },
];
const section1 = [
  {
    title: "Chic Jumpsuits",
    src: temp1,
  },
  {
    title: "Sophisticated",
    src: temp2,
  },
  {
    title: "Trendy",
    src: temp3,
  },
  {
    title: "Fire",
    src: temp4,
  },
];
const section2 = [
  {
    title: "Chic Jumpsuits",
    src: temp5,
  },
  {
    title: "Sophisticated",
    src: temp6,
  },
  {
    title: "Trendy",
    src: temp7,
  },
  {
    title: "Fire",
    src: temp8,
  },
];
const section3 = [
  {
    title: "Chic Jumpsuits",
    src: temp9,
  },
  {
    title: "Sophisticated",
    src: temp10,
  },
  {
    title: "Trendy",
    src: temp11,
  },
  {
    title: "Fire",
    src: temp12,
  },
];


const data = [
  {
    title: "Consequat",
    content: (
      <div>
        <p className="text-black text-xl sm:text-2xl font-normal mb-8">
          Embrace the Essence of Timeless Fashion with Our Impeccable Selection
          of Premium Apparel
        </p>
        <FocusCards cards={section1} cols={2} />
      </div>
    ),
  },
  {
    title: "Shop by Category",
    content: (
      <div>
        <p className="text-black text-xl sm:text-2xl font-normal mb-8">
          Discover the Perfect Fit
        </p>
        <FocusCards cards={section2} cols={2} />
      </div>
    ),
  },
  {
    title: "Discover New Arrivals",
    content: (
      <div>
        <p className="text-black text-xl sm:text-2xl font-normal mb-4">
          Elevate Your Wardrobe with Our Exquisite Selection of Premium Fashion
          Pieces
        </p>
        <FocusCards cards={section3} cols={2} />
      </div>
    ),
  },
];

function Collection() {
  return (
    <div className="bg-gradient-to-b from-white via-light-custom-pink to-custom-pink h-[fit-content] mt-10">
      <div className="text-center prata flex flex-col items-center justify-center p-5 mt-20">
        {/* Responsive Heading */}
        <div className="h-auto items-center px-4 w-full text-center">
          <div className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black leading-tight">
            Explore the greatest collection of
            <FlipWords words={words} />
          </div>
          <div className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-500 mt-5">
            Embrace the Essence of Timeless Fashion with our Impeccable
            Selection of Premium Apparel
          </div>
        </div>

        {/* Responsive Cards */}
        <div className="w-full px-4 mt-10">
          <FocusCards cards={cards} cols={3} smCols={1} lgCols={3} />
        </div>
      </div>

      {/* Responsive Timeline Section */}
      <div className="w-full px-4 mt-10">
        <Timeline data={data} />
      </div>
    </div>
  );
}

export default Collection;
